import Avatar from "@/views/Components/Avatar";
import { Link } from "react-router";
import { RoutePaths } from "../../routes";
import Logo from "./Logo";
import AddWishButton from "../AddWishButton";
import MenuItem from "./MenuItem";
import { useSelector } from "react-redux";
import { useCurrentUser, useIsMyWishlist } from "../../../data/hooks";
import { Spin } from "antd";
import NotificationBell from "./NotificationBell";
import { selectDefaultWishlistId } from "@/data/redux/wishlist/selectors";

export default function Header() {
  const { user, authStateLoaded } = useCurrentUser();
  const wishlistId = useSelector(selectDefaultWishlistId);
  const isMyWishlist = useIsMyWishlist();
  return (
    <div className="wish-bg-white hidden h-12 items-center gap-4 px-6 py-1.5 md:flex">
      <Link to="/" viewTransition>
        <Logo />
      </Link>
      <MenuItem path={RoutePaths.myDefaultWishlist} title="Wishlist" />
      {user && <MenuItem path={RoutePaths.friends} title="Friends" />}
      {user && <MenuItem path={RoutePaths.reserved} title="Reserved" />}
      <div className="grow"></div>
      {wishlistId && isMyWishlist && <AddWishButton />}
      {!authStateLoaded && <Spin />}
      <NotificationBell />
      {user && authStateLoaded && (
        <Link to={RoutePaths.account} viewTransition>
          <Avatar uid={user.uid} />
        </Link>
      )}
      {!user && authStateLoaded && (
        <MenuItem path={RoutePaths.login} title="Login" />
      )}
    </div>
  );
}
